import React from "react";
import "./GiftVoucher.css";
import img7 from "../images/img7.jpg";

const GiftVoucher = () => {
  return (
    <div className="gift-voucher">
      <div className="gift-voucher-content">
        <div className="gift-voucher-content1">
            <h2>Gift Voucher</h2>
        </div>
        <img src={img7} alt="" />
      </div>
    </div>
  );
};

export default GiftVoucher;
